var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_659_3218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#EAB624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 30.5557C14.3054 30.5557 9.06789 31.5098 4.90039 33.1073C8.56706 37.3273 13.9696 39.9998 19.9996 39.9998C26.0296 39.9998 31.4321 37.3273 35.0987 33.1065C30.9312 31.5098 25.6937 30.5557 19.9996 30.5557Z",
    fill: "#AAE5F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 35.8335C18.6192 35.8335 17.5 34.7143 17.5 33.3335V25.8335H22.5V33.3335C22.5 34.7143 21.3808 35.8335 20 35.8335Z",
    fill: "#00A2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3604 18.9032L31.002 19.1923L32.5937 10.1648C32.6737 9.71151 32.3712 9.27901 31.9178 9.19984C31.4645 9.11984 31.032 9.42234 30.9529 9.87567L29.3604 18.9032Z",
    fill: "#BBF1E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6387 18.9032L8.99707 19.1923L7.40541 10.1648C7.32541 9.71151 7.62791 9.27901 8.08124 9.19984C8.53457 9.11984 8.96707 9.42234 9.04624 9.87567L10.6387 18.9032Z",
    fill: "#BBF1E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1663 20.833H10.833C9.45217 20.833 8.33301 19.7138 8.33301 18.333C8.33301 16.9522 9.45217 15.833 10.833 15.833H29.1663C30.5472 15.833 31.6663 16.9522 31.6663 18.333C31.6663 19.7138 30.5472 20.833 29.1663 20.833Z",
    fill: "#00A2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3337 27.6042H11.667V16.7708C11.667 12.1683 15.3978 8.4375 20.0003 8.4375C24.6028 8.4375 28.3337 12.1683 28.3337 16.7708V27.6042Z",
    fill: "#AAE5F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4095 17.3608H22.7428C21.822 17.3608 21.0762 18.1067 21.0762 19.0275C21.0762 19.9483 21.822 20.6942 22.7428 20.6942H24.4095C25.3303 20.6942 26.0762 19.9483 26.0762 19.0275C26.0762 18.1075 25.3295 17.3608 24.4095 17.3608Z",
    fill: "#00A2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2562 17.3608H15.5895C14.6687 17.3608 13.9229 18.1067 13.9229 19.0275C13.9229 19.9483 14.6687 20.6942 15.5895 20.6942H17.2562C18.177 20.6942 18.9229 19.9483 18.9229 19.0275C18.9229 18.1075 18.177 17.3608 17.2562 17.3608Z",
    fill: "#00A2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 24.0273H15V24.8607H25V24.0273Z",
    fill: "#00A2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0784 13.4023H21.9209L22.7851 8.21816C23.0726 6.49733 21.7451 4.93066 20.0001 4.93066C18.2551 4.93066 16.9276 6.49733 17.2151 8.219L18.0784 13.4023Z",
    fill: "#00A2D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_659_3218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.5ff726b25ed3fe03fbc2b1a6fbc05f8a.svg";
export { ForwardRef as ReactComponent };